import { InsuranceCalcMethodType, InsuranceOutputType } from "./insuranceCalcTypes";

const insuranceCalcKobstederne: InsuranceCalcMethodType = ({
  insuranceInput: input,
  valueConfig: config,
}, isPrivate, isInactivePeriod, isVan) => {
  const { active, vehiclePrice, isUserOver26, glassDamage, roadAssistance } = input;



  // Insurance-addons & annually prices
  const insuranceAddOns = {
    roadHelp: 494,
    roadHelpVan: 1111,
    glassDamage: 1376,
    glassDamageSelfRisk: 1881,
  };
  const roadHelp = isVan ? insuranceAddOns.roadHelpVan : insuranceAddOns.roadHelp;

  //Init output
  let output: InsuranceOutputType = {
    insurable: true,
    monthlyPayment: null,
    ownRisk: null,
    roadAssistance: roadHelp,
    glassDamage: insuranceAddOns.glassDamage,
    roadAssistanceMonthlyPayment: Math.ceil(roadHelp / 12 / 10) * 10,
    glassDamageMonthlyPayment: Math.ceil(insuranceAddOns.glassDamage / 12 / 10) * 10,
    glassDamageSelfRisk: insuranceAddOns.glassDamageSelfRisk,
  };

  if (!active || !vehiclePrice) return output;

  // Check if insurable for under26:
  if (isPrivate) {
    const insuranceClassesUnder26 = insuranceClasses.filter((c) => !!c.priceUnder26);
    const maxPriceUnder26 = insuranceClassesUnder26[insuranceClassesUnder26.length - 1].amount;

    if (vehiclePrice > maxPriceUnder26 && !isUserOver26) {
      output.insurable = false;
      return output;
    }
  }

  //Calculation
  for (let insuranceClass of insuranceClasses) {
    if ((vehiclePrice || 0) <= insuranceClass.amount) {
      output.monthlyPayment = insuranceClass.price;
      output.ownRisk = insuranceClass.selfRiskPrice;

      if (!isUserOver26) {
        output.monthlyPayment = insuranceClass.priceUnder26 || 0;
        output.ownRisk = insuranceClass.selfRiskPriceUnder26;
        output.insurable = output.monthlyPayment !== null && output.ownRisk !== null;
      }
      break;
    }
  }



  /** Derudover skal der betales skadeforsikringsafgift til Staten af prisen for skadeforsikringer,
   *  dog med undtagelse af motoransvarsforsikringer og bådforsikringer.
   *  Afgiften udgør 1,1 % af prisen på dine forsikringer og skal betales,
   *  hver gang du betaler dine forsikringer.
   * @see https://tryg.dk/om-tryg/gebyrer-og-afgifter
   * @see https://www.codan.dk/erhverv/kundeservice/detmedsmaat#afgifter
   */
  // Skadeforsikringsafgift: Add 1,1% of prize to monthly payment
  // Miljøafgift: Add kr 84,- to monthly payment
  const INSURANCE_DAMAGE_TAX_RATE = 0.011;
  const INSURANCE_ENVIRONMENT_TAX = 84;
  const insuranceCommission = config.insuranceCommission.value || 0;
  const monthlyInsuranceEnvironmentTax = INSURANCE_ENVIRONMENT_TAX / 12;
  const monthlyInsuranceCommission = insuranceCommission / 12;

  const totalPayment = (output.monthlyPayment || 0) // Bad naming >(
  let taxedMonthlyPayment = totalPayment / 12;
  const damageInsuranceTax = taxedMonthlyPayment * INSURANCE_DAMAGE_TAX_RATE;
  taxedMonthlyPayment += damageInsuranceTax;
  taxedMonthlyPayment += monthlyInsuranceEnvironmentTax;
  taxedMonthlyPayment += monthlyInsuranceCommission;

  output.monthlyPayment = Math.ceil(taxedMonthlyPayment / 10) * 10;


  if (isInactivePeriod) {
    output.monthlyPayment = Math.ceil(output.monthlyPayment / 2);
  }

  if (roadAssistance) output.monthlyPayment += output.roadAssistanceMonthlyPayment;
  if (glassDamage) {
    output.monthlyPayment += output.glassDamageMonthlyPayment;
  }

  return output;
};

export default insuranceCalcKobstederne;


// NOTE: 01-28-2026: Fie wrote me [Nicolai Johnsen] that Lya wants us to adjust the prices for these amounts to the following.
// The reason is that we want to be safe-guarded against us removing the profit we earn on the insurance.

// amount: 300000,
//  price: 9293
//
//  amount: 400000,
//  price: 12929,
//
//  amount: 500000,
//  price: 13485,
//
//  amount: 600000,
//  price: 14984,
//
//  amount: 750000,
//  price: 18682



// Markup values of {[amount]: absoluteMarkupValue}
const markup = {
  300000: 300,
  400000: 600,
  500000: 600,
  600000: 600,
  750000: 600,
}
// Hvert år pr. forfald 1. januar forhøjes raterne og selvrisiko med indeks.
// Aftalen er pr. 1. februar 2026 opdateret med indeks for 2026.
const insuranceClasses = [
  {
    amount: 100000,
    price: 6810,
    selfRiskPrice: 6087,
    priceUnder26: 13548,
    selfRiskPriceUnder26: 14940,
  },
  {
    amount: 200000,
    price: 7946,
    selfRiskPrice: 6087,
    priceUnder26: 15808,
    selfRiskPriceUnder26: 14940,
  },
  {
    amount: 300000,
    price: 8993 + markup[300000],
    // marked up to: 9293
    selfRiskPrice: 8853,
    priceUnder26: 17153,
    selfRiskPriceUnder26: 14940,
  },
  {
    amount: 400000,
    price: 12329 + markup[400000],
    // marked up to: 12929
    selfRiskPrice: 8853,
    priceUnder26: null,
    selfRiskPriceUnder26: null,
  },
  {
    amount: 500000,
    price: 12885 + markup[500000],
    // marked up to: 13485
    selfRiskPrice: 12727,
    priceUnder26: null,
    selfRiskPriceUnder26: null,
  },
  {
    amount: 600000,
    price: 14384 + markup[600000],
    // marked up to: 14984
    selfRiskPrice: 18260,
    priceUnder26: null,
    selfRiskPriceUnder26: null,
  },
  {
    amount: 750000,
    price: 18082 + markup[750000],
    // marked up to: 18682
    selfRiskPrice: 18260,
    priceUnder26: null,
    selfRiskPriceUnder26: null,
  },
];


// NOTE: copied the numbers for 2026 for posterity
// Hvert år pr. forfald 1. januar forhøjes raterne og selvrisiko med indeks.
// Aftalen er pr. 1. februar 2026 opdateret med indeks for 2026.
// const insuranceClasses = [
//   {
//     amount: 100000,
//     price: 6810,
//     selfRiskPrice: 6087,
//     priceUnder26: 13548,
//     selfRiskPriceUnder26: 14940,
//   },
//   {
//     amount: 200000,
//     price: 7946,
//     selfRiskPrice: 6087,
//     priceUnder26: 15808,
//     selfRiskPriceUnder26: 14940,
//   },
//   {
//     amount: 300000,
//     price: 8993,
//     selfRiskPrice: 8853,
//     priceUnder26: 17153,
//     selfRiskPriceUnder26: 14940,
//   },
//   {
//     amount: 400000,
//     price: 12329,
//     selfRiskPrice: 8853,
//     priceUnder26: null,
//     selfRiskPriceUnder26: null,
//   },
//   {
//     amount: 500000,
//     price: 12885,
//     selfRiskPrice: 12727,
//     priceUnder26: null,
//     selfRiskPriceUnder26: null,
//   },
//   {
//     amount: 600000,
//     price: 14384,
//     selfRiskPrice: 18260,
//     priceUnder26: null,
//     selfRiskPriceUnder26: null,
//   },
//   {
//     amount: 750000,
//     price: 18082,
//     selfRiskPrice: 18260,
//     priceUnder26: null,
//     selfRiskPriceUnder26: null,
//   },
// ];
